import { memo } from "react";
import styled from "styled-components";

const SpanStyles = styled.span`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.body.b3.weight};
  font-size: ${({ theme }) => theme.typography.body.b3.size};
  line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
  color: ${({ theme }) => theme.colors.semantic.text.strong};
`;

const Span = ({ children, className, style, onClick }) => (
  <SpanStyles onClick={onClick} className={className} style={{ ...style }}>
    {children}
  </SpanStyles>
);

export default memo(Span);
